const NORMAL = "normal";
const JSONB = "jsonb";

export const FILTER_LABELS = {
  dateRange: "Date Range",
  salesPerson: "Sales Person",
  recruiter: "Recruiter",
  client: "Client",
  country: "Country",
};

export const REPORT_MANDATORY_OPTIONS = [];

export const REPORT_INITIAL_OPTIONS = [
  {
    sortValue: "job.job_submission_data.jobId",
    label: "Pulse Job ID",
    value: "job.jobSubmissionData.jobId",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.jobTitle",
    label: "Job Title",
    value: "job.jobSubmissionData.jobTitle",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.accountName",
    label: "Client Name",
    value: "job.jobSubmissionData.accountName",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job.job_submission_data.accountOwner",
    label: "Sales Person",
    value: "job.jobSubmissionData.accountOwner",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "users.first_name",
    label: "Recruiter",
    value: "createdByName",
    sort: true,
    expand: true,
    sortType: NORMAL,
  },
];

export const INITAL_CANDIDATE_STATIC_REPORT_FILTER = [
  { label: FILTER_LABELS.dateRange, field: "job_timeline.created_at" },
  {
    label: FILTER_LABELS.salesPerson,
    field: "job.job_submission_data.accountOwner",
  },
  { label: "Recruiter", field: "users.first_name + users.last_name" },
  { label: "Client", field: "job.job_submission_data.accountName" },
  { label: "Country", field: "job.job_submission_data.country" },
];
